'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerRecord = require('../../records/PlayerRecord');

var _PlayerRecord2 = _interopRequireDefault(_PlayerRecord);

var _store = require('../../../store');

var _store2 = _interopRequireDefault(_store);

var _playerFunctions = require('./playerFunctions');

var _constants = require('../../actions/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks that a specific playerId exists
 *
 * @param {Object} state - The players state
 * @param {string} playerId - The playerId to check exists
 * @returns {boolean} - If the specified player exists
 */
/* eslint-disable no-console */
/*
 * Copyright 2016 hudl
 * All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule PlayersReducer
 * 
 */

var checkPlayerExists = function checkPlayerExists(state, playerId) {
  if (!state[playerId]) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('No Player exists under that Id: ', playerId);
    }
    return false;
  }
  return true;
};

/**
 * Utilised in all actions that affect specific player instances, to ensure that any
 * action can only affect an existing player. If it does, execute the associated function.
 *
 * @param {Object} state - The player state
 * @param {action} action - The action that was dispatched
 * @param {function} func - The associated function
 * @returns {Object} - The new state
 */
var playerActionHandler = function playerActionHandler(state, action, func) {
  if (checkPlayerExists(state, action.playerId)) {
    return func(state, action);
  }
  return state;
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var handler = playerActionHandler.bind(null, state, action);

  switch (action.type) {
    case _constants.CREATE_PLAYER_INSTANCE:
      var player = new _PlayerRecord2.default();
      state[action.playerId] = player.set('playerId', action.playerId);
      return Object.assign({}, state);
    case _constants.DESTROY_PLAYER_INSTANCE:
      delete state[action.playerId];
      _store2.default.getPlayerInstance(action.playerId).destroy();
      _store2.default.removePlayerInstance(action.playerId);
      return Object.assign({}, state);
    case _constants.INSERT_PLAYABLE:
      return handler(_playerFunctions.insertPlayable);
    case _constants.REMOVE_PLAYABLE:
      return handler(_playerFunctions.removePlayable);
    case _constants.REORDER_PLAYABLE:
      return handler(_playerFunctions.reorderPlayable);
    case _constants.SET_AD_BEGAN:
      return handler(_playerFunctions.setAdBegan);
    case _constants.SET_AD_ENDED:
      return handler(_playerFunctions.setAdEnded);
    case _constants.SET_ASPECT_RATIO:
      return handler(_playerFunctions.setAspectRatio);
    case _constants.SET_AUTO_ADVANCE:
      return handler(_playerFunctions.setAutoAdvance);
    case _constants.SET_AUTO_PLAY:
      return handler(_playerFunctions.setAutoPlay);
    case _constants.SET_STREAM:
      return handler(_playerFunctions.setStream);
    case _constants.SET_STREAM_INTERNAL:
      return handler(_playerFunctions.setStreamInternal);
    case _constants.SET_SWITCHING_STREAMS:
      return handler(_playerFunctions.setSwitchingStreams);
    case _constants.SET_CAN_PLAY:
      return handler(_playerFunctions.setCanPlay);
    case _constants.SET_FOCUS:
      return handler(_playerFunctions.setFocus);
    case _constants.SET_LOOPING:
      return handler(_playerFunctions.setLooping);
    case _constants.SET_MUTE:
    case _constants.SET_MUTE_INTERNAL:
      return handler(_playerFunctions.setMute);
    case _constants.SET_PAUSED:
    case _constants.SET_PAUSED_INTERNAL:
      return handler(_playerFunctions.pause);
    case _constants.SET_PLAY:
    case _constants.SET_PLAY_INTERNAL:
      return handler(_playerFunctions.play);
    case _constants.SET_PLAYING_INDEX:
    case _constants.SET_PLAYING_INDEX_INTERNAL:
      return handler(_playerFunctions.setPlayingIndex);
    case _constants.SET_PLAYBACK_RATE:
      return handler(_playerFunctions.setPlaybackRate);
    /**
     * Look into potential new API, SET_PLAYLIST, SET_VIDEO ; responsible, for emptying
     * each other - transition from playlist as example
     */
    case _constants.SET_PLAYABLES:
      return handler(_playerFunctions.setPlayables);
    case _constants.SET_QUALITY:
    case _constants.SET_QUALITY_INTERNAL:
      return handler(_playerFunctions.setQuality);
    case _constants.SET_QUALITIES:
      return handler(_playerFunctions.setQualities);
    case _constants.SET_QUEUE_ENDED:
      return handler(_playerFunctions.setQueueEnded);
    case _constants.SET_SEEKING:
      return handler(_playerFunctions.setSeeking);
    case _constants.SET_VOLUME:
    case _constants.SET_VOLUME_INTERNAL:
      return handler(_playerFunctions.setVolume);
    case _constants.TOGGLE_FULLSCREEN:
      return handler(_playerFunctions.toggleFullscreen);
    case _constants.SET_CONTEXT_MENU:
      return handler(_playerFunctions.setContextMenu);
    case _constants.SET_DURATION_MS:
      return handler(_playerFunctions.setDurationMs);
    case _constants.SET_DIMENSIONS:
      return handler(_playerFunctions.setDimensions);
    case _constants.SET_EXPECTED_DURATION_MS:
      return handler(_playerFunctions.setExpectedDurationMs);
    case _constants.SET_LIVE:
      return handler(_playerFunctions.setLive);
    case _constants.UPDATE_PLAYABLES:
      return handler(_playerFunctions.updatePlayables);
    case _constants.DISABLE_AUDIO:
      return handler(_playerFunctions.disableAudio);
    case _constants.SET_ERROR_INTERNAL:
      return handler(_playerFunctions.setError);
    default:
      return state;
  }
};

module.exports = exports['default'];